import { z } from "zod";
export const previewUrlSchema = z.object({
    full: z.string(),
    preview: z.string().optional(),
});
export const previewUrlWithSizeSchema = z.object({
    full: z.string(),
    preview: z.string().optional(),
    /** The width and height of the full-sized image. This is likely used to
     * prevent sizing issues when transiting between full and preview images. Note
     * that if these sizing issues are pervasive, we might move width, height into
     * previewUrlSchema (i.e. require them for all preview images). */
    width: z.number(),
    height: z.number(),
});
export const imageSizeSchema = z.union([
    z.object({ width: z.number(), height: z.number() }),
    z.object({ width: z.number() }),
    z.object({ height: z.number() }),
]);
